module.exports = {
	"contractName": "Owned",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getOwner",
			"outputs": [
				{
					"name": "contractOwner",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x6060604052341561000f57600080fd5b336000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055506102578061005e6000396000f300606060405260043610610057576000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff168063893d20e81461005c5780638da5cb5b146100b1578063f2fde38b14610106575b600080fd5b341561006757600080fd5b61006f61013f565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b34156100bc57600080fd5b6100c4610168565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561011157600080fd5b61013d600480803573ffffffffffffffffffffffffffffffffffffffff1690602001909190505061018d565b005b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415156101e857600080fd5b806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550505600a165627a7a723058204141e7bc8d321b5808c4c97bdf9136c27bcd390c1c86a68cd2f9810b90dee7670029",
	"deployedBytecode": "0x606060405260043610610057576000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff168063893d20e81461005c5780638da5cb5b146100b1578063f2fde38b14610106575b600080fd5b341561006757600080fd5b61006f61013f565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b34156100bc57600080fd5b6100c4610168565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561011157600080fd5b61013d600480803573ffffffffffffffffffffffffffffffffffffffff1690602001909190505061018d565b005b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415156101e857600080fd5b806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550505600a165627a7a723058204141e7bc8d321b5808c4c97bdf9136c27bcd390c1c86a68cd2f9810b90dee7670029",
	"sourceMap": "28:416:1:-;;;79:61;;;;;;;;122:10;114:5;;:18;;;;;;;;;;;;;;;;;;28:416;;;;;;",
	"deployedSourceMap": "28:416:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;238:97;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;50:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;343:98;;;;;;;;;;;;;;;;;;;;;;;;;;;;238:97;282:21;322:5;;;;;;;;;;;315:12;;238:97;:::o;50:20::-;;;;;;;;;;;;;:::o;343:98::-;200:5;;;;;;;;;;;186:19;;:10;:19;;;178:28;;;;;;;;425:8;417:5;;:16;;;;;;;;;;;;;;;;;;343:98;:::o",
	"source": "pragma solidity ^0.4.16;\r\n\r\ncontract Owned {\r\n    address public owner;\r\n\r\n    function Owned() public {\r\n        owner = msg.sender;\r\n    }\r\n\r\n    modifier onlyOwner {\r\n        require(msg.sender == owner);\r\n        _;\r\n    }\r\n    \r\n    function getOwner() constant public returns(address contractOwner){\r\n        return owner;\r\n    }\r\n\r\n    function transferOwnership(address newOwner) onlyOwner  public {\r\n        owner = newOwner;\r\n    }\r\n}",
	"sourcePath": "C:\\Users\\nktpa\\Desktop\\truffle-react-auth\\contracts\\Owned.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/C/Users/nktpa/Desktop/truffle-react-auth/contracts/Owned.sol",
			"exportedSymbols": {
				"Owned": [
					280
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 237,
				"name": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"attributes": {
					"baseContracts": [
						null
					],
					"contractDependencies": [
						null
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						280
					],
					"name": "Owned",
					"scope": 281
				},
				"children": [
					{
						"attributes": {
							"constant": false,
							"name": "owner",
							"scope": 280,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "address",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "address",
									"type": "address"
								},
								"id": 238,
								"name": "ElementaryTypeName",
								"src": "50:7:1"
							}
						],
						"id": 239,
						"name": "VariableDeclaration",
						"src": "50:20:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "Owned",
							"payable": false,
							"scope": 280,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 240,
								"name": "ParameterList",
								"src": "93:2:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 241,
								"name": "ParameterList",
								"src": "103:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 239,
															"type": "address",
															"value": "owner"
														},
														"id": 242,
														"name": "Identifier",
														"src": "114:5:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 292,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 243,
																"name": "Identifier",
																"src": "122:3:1"
															}
														],
														"id": 244,
														"name": "MemberAccess",
														"src": "122:10:1"
													}
												],
												"id": 245,
												"name": "Assignment",
												"src": "114:18:1"
											}
										],
										"id": 246,
										"name": "ExpressionStatement",
										"src": "114:18:1"
									}
								],
								"id": 247,
								"name": "Block",
								"src": "103:37:1"
							}
						],
						"id": 248,
						"name": "FunctionDefinition",
						"src": "79:61:1"
					},
					{
						"attributes": {
							"name": "onlyOwner",
							"visibility": "internal"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 249,
								"name": "ParameterList",
								"src": "167:0:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 295,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 250,
														"name": "Identifier",
														"src": "178:7:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "==",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 292,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 251,
																		"name": "Identifier",
																		"src": "186:3:1"
																	}
																],
																"id": 252,
																"name": "MemberAccess",
																"src": "186:10:1"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 239,
																	"type": "address",
																	"value": "owner"
																},
																"id": 253,
																"name": "Identifier",
																"src": "200:5:1"
															}
														],
														"id": 254,
														"name": "BinaryOperation",
														"src": "186:19:1"
													}
												],
												"id": 255,
												"name": "FunctionCall",
												"src": "178:28:1"
											}
										],
										"id": 256,
										"name": "ExpressionStatement",
										"src": "178:28:1"
									},
									{
										"id": 257,
										"name": "PlaceholderStatement",
										"src": "217:1:1"
									}
								],
								"id": 258,
								"name": "Block",
								"src": "167:59:1"
							}
						],
						"id": 259,
						"name": "ModifierDefinition",
						"src": "148:78:1"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getOwner",
							"payable": false,
							"scope": 280,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 260,
								"name": "ParameterList",
								"src": "255:2:1"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "contractOwner",
											"scope": 267,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 261,
												"name": "ElementaryTypeName",
												"src": "282:7:1"
											}
										],
										"id": 262,
										"name": "VariableDeclaration",
										"src": "282:21:1"
									}
								],
								"id": 263,
								"name": "ParameterList",
								"src": "281:23:1"
							},
							{
								"children": [
									{
										"attributes": {
											"functionReturnParameters": 263
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"overloadedDeclarations": [
														null
													],
													"referencedDeclaration": 239,
													"type": "address",
													"value": "owner"
												},
												"id": 264,
												"name": "Identifier",
												"src": "322:5:1"
											}
										],
										"id": 265,
										"name": "Return",
										"src": "315:12:1"
									}
								],
								"id": 266,
								"name": "Block",
								"src": "304:31:1"
							}
						],
						"id": 267,
						"name": "FunctionDefinition",
						"src": "238:97:1"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "transferOwnership",
							"payable": false,
							"scope": 280,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "newOwner",
											"scope": 279,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 268,
												"name": "ElementaryTypeName",
												"src": "370:7:1"
											}
										],
										"id": 269,
										"name": "VariableDeclaration",
										"src": "370:16:1"
									}
								],
								"id": 270,
								"name": "ParameterList",
								"src": "369:18:1"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 273,
								"name": "ParameterList",
								"src": "406:0:1"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 259,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 271,
										"name": "Identifier",
										"src": "388:9:1"
									}
								],
								"id": 272,
								"name": "ModifierInvocation",
								"src": "388:9:1"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 239,
															"type": "address",
															"value": "owner"
														},
														"id": 274,
														"name": "Identifier",
														"src": "417:5:1"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 269,
															"type": "address",
															"value": "newOwner"
														},
														"id": 275,
														"name": "Identifier",
														"src": "425:8:1"
													}
												],
												"id": 276,
												"name": "Assignment",
												"src": "417:16:1"
											}
										],
										"id": 277,
										"name": "ExpressionStatement",
										"src": "417:16:1"
									}
								],
								"id": 278,
								"name": "Block",
								"src": "406:35:1"
							}
						],
						"id": 279,
						"name": "FunctionDefinition",
						"src": "343:98:1"
					}
				],
				"id": 280,
				"name": "ContractDefinition",
				"src": "28:416:1"
			}
		],
		"id": 281,
		"name": "SourceUnit",
		"src": "0:444:1"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.19+commit.c4cbbb05.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0xdfce7268dbe0453d72f28427affe04cbf3ef7521"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-03-13T19:12:19.975Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Owned.json
// module id = 1205
// module chunks = 0